import { useHistory } from 'react-router-dom';
import { Box } from 'reflexbox';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

import GoalListItemCompetency from '../../../../packages/kakapo-ui-kit/components/goals/list/GoalListItemCompetency';
import SettingsItem from '../../../generic/SettingsItem';

export default function GoalTemplateRow(props: {
	jobTitle: graphql.JobTitle;
	goalTemplate: graphql.GoalTemplate;
}) {
	const history = useHistory();
	const { localize } = useLocalize();

	return (
		<SettingsItem
			item={props.goalTemplate}
			title={(template: graphql.GoalTemplate) => localize(template.title).text}
			onEdit={() => history.push(`/settings/goals/${props.goalTemplate.id}`)}
			onRefresh={() => {}}
		>
			{props.goalTemplate.competency && (
				<Box mt={3}>
					<GoalListItemCompetency competency={props.goalTemplate.competency} />
				</Box>
			)}
		</SettingsItem>
	);
}
